// Minimal classNames joiner (filters falsy values).
export const cn = (...parts) => parts.filter(Boolean).join(' ');
